export var UIProperty = {
    blockLibrary: 'blockLibrary',
    palette: 'palette',
};
export var settingsActions;
(function (settingsActions) {
    settingsActions["FETCH"] = "settings:FETCH";
    settingsActions["SUCCESS"] = "settings:SUCCESS";
    settingsActions["FAILURE"] = "settings:FAILURE";
    settingsActions["UPDATE"] = "settings:UPDATE";
    settingsActions["DEFAULT"] = "settings:DEFAULT";
    settingsActions["TOGGLE_UI"] = "settings:TOGGLE_UI";
})(settingsActions || (settingsActions = {}));
